export default __webpack_public_path__ + "static/walgreens-logo-vector-134e21e51147caa33eb4a276f0edc295.svg";